<div class="chat-input-wrapper">
  <form class="input-form" (ngSubmit)="submitForm()" (submit)="$event.preventDefault()">
    <div class="input-container fade-in">
      <!-- File Upload Notification Area -->
      <div class="file-upload-notification" *ngIf="state.uploadedFile">
        <mat-icon class="upload-icon">cloud_upload</mat-icon>
        <!-- <span class="file-name">{{ state.uploadedFile.file_name }}</span> -->
        <span class="file-name">{{ getFormattedFileName(state.uploadedFile.file_name) }}</span>
        <button mat-icon-button (click)="removeUploadedFile()" matTooltip="Remove file">
          <mat-icon>clear</mat-icon>
        </button>
      </div>

      <app-text-input
        [userMessage]="userMessage"
        [placeholder]="placeholder"
        [disabled]="false"
        [autoFocus]="!isMobile"
        [processing]="(state.processing$ | async) || false"
        (userMessageChange)="onUserMessageChange($event)"
        (submitMessage)="onTextInputSubmit()"
        (keydownEvent)="onTextInputKeydown($event)"
        #textInputComponent
      ></app-text-input>

      <!-- Button Row -->
      <div class="button-row">
        <!-- Input Actions Component -->
        <app-input-actions
          [isUploadButtonDisabled]="isUploadButtonDisabled"
          [uploadedFile]="state.uploadedFile"
          [fileTooltip]="fileTooltip"
          [isMobile]="isMobile"
          (newChat)="newChatClicked()"
          (uploadFileClick)="uploadFile()"
          (captureImageClick)="captureImage()"
          (fileSelected)="onFileSelected($event)"
          (showComingSoon)="showComingSoonMessage()"
          (scrollToBottom)="scrollToBottom()"
          (testFunction)="testFunction()"
          #inputActionsComponent
        ></app-input-actions>

        <!-- Notification Area -->
        <div class="notification-area" *ngIf="notifications.length > 0">
          <ng-container *ngFor="let notification of notifications">
            <div
              class="notification-message"
              (click)="notification.full_click && notification.action && notification.action()"
              [@fade]
            >
              {{ notification.content }}
              <button
                mat-icon-button
                *ngIf="notification.button"
                (click)="notification.action && notification.action()"
              >
                <mat-icon>{{ notification.button }}</mat-icon>
              </button>
            </div>
          </ng-container>
        </div>

        <!-- Submit Button and Spinner -->
        <div class="submit-container">
          <mat-spinner
            *ngIf="(state.processing$ | async) && false"
            diameter="34"
            class="processing-spinner"
          ></mat-spinner>

          <!-- Send button -->
          <button
            mat-icon-button
            type="button"
            class="send-button"
            [disabled]="state.processing$ | async"
            *ngIf="userMessage.trim().length > 0 && !(state.processing$ | async)"
            matTooltip="Send message"
            matTooltipPosition="below"
            (click)="submitForm()"
          >
            <mat-icon>{{ sendButtonIcon }}</mat-icon>
          </button>

          <!-- Record button -->
          <app-audio-recorder
            *ngIf="userMessage.trim().length === 0 && !(state.processing$ | async)"
            [disabled]="false"
            [visible]="true"
            [preferredFormat]="configService.audioCaptureFormat || 'webm'"
            (recordingStarted)="onRecordingStarted()"
            (recordingStopped)="onRecordingStopped()"
            (audioRecorded)="onAudioRecorded($event)"
            (recordingError)="onRecordingError($event)"
          ></app-audio-recorder>

          <!-- Stop button -->
          <button
            mat-icon-button
            type="button"
            class="stop-button send-button pulsate"
            [disabled]="!(state.processing$ | async)"
            (click)="stopProcessing()"
            *ngIf="state.processing$ | async"
          >
            <mat-icon>stop</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
